"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var sdk_1 = require("@hashgraph/sdk");
var deviceAccess_1 = require("../../hw/deviceAccess");
var network_1 = require("./api/network");
var utils_1 = require("./utils");
var hw_app_hedera_1 = __importDefault(require("./hw-app-hedera"));
var signOperation = function (_a) {
    var account = _a.account, transaction = _a.transaction, deviceId = _a.deviceId;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (o) {
            void (function () {
                return __awaiter(this, void 0, void 0, function () {
                    var hederaTransaction, accountPublicKey, operation, err_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 4, , 5]);
                                o.next({
                                    type: "device-signature-requested"
                                });
                                return [4 /*yield*/, (0, network_1.buildUnsignedTransaction)({
                                        account: account,
                                        transaction: transaction
                                    })];
                            case 1:
                                hederaTransaction = _a.sent();
                                accountPublicKey = sdk_1.PublicKey.fromString(account.seedIdentifier);
                                return [4 /*yield*/, hederaTransaction.signWith(accountPublicKey, function (bodyBytes) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, new hw_app_hedera_1["default"](transport).signTransaction(bodyBytes)];
                                                case 1: return [2 /*return*/, _a.sent()];
                                            }
                                        });
                                    }); })];
                            case 2:
                                _a.sent();
                                o.next({
                                    type: "device-signature-granted"
                                });
                                return [4 /*yield*/, buildOptimisticOperation({
                                        account: account,
                                        transaction: transaction
                                    })];
                            case 3:
                                operation = _a.sent();
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        // NOTE: this needs to match the inverse operation in js-broadcast
                                        signature: Buffer.from(hederaTransaction.toBytes()).toString("base64"),
                                        expirationDate: null
                                    }
                                });
                                o.complete();
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _a.sent();
                                o.error(err_1);
                                return [3 /*break*/, 5];
                            case 5: return [2 /*return*/];
                        }
                    });
                });
            })();
        });
    });
};
function buildOptimisticOperation(_a) {
    var account = _a.account, transaction = _a.transaction;
    return __awaiter(this, void 0, void 0, function () {
        var operation;
        return __generator(this, function (_b) {
            operation = {
                id: "".concat(account.id, "--OUT"),
                hash: "",
                type: "OUT",
                value: transaction.amount,
                fee: utils_1.estimatedFees,
                blockHash: null,
                blockHeight: null,
                senders: [account.freshAddress.toString()],
                recipients: [transaction.recipient],
                accountId: account.id,
                date: new Date(),
                extra: {}
            };
            return [2 /*return*/, operation];
        });
    });
}
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map